import {State} from '../types'

export const isRequestPending = (state: State, requestName: string) =>
  Boolean(state.pendingRequests.requestNames.find((name) => name === requestName))
